import {Routes} from '@angular/router';
import {HomepageComponent} from './components/homepage/homepage.component';
import {MobileApplicationDevComponent} from './components/mobile-application-dev/mobile-application-dev.component';
import {FintechSolutionsComponent} from './components/fintech-solutions/fintech-solutions.component';
import {GamingPlatformComponent} from './components/gaming-platform/gaming-platform.component';
import {ContactUsComponent} from './components/contact-us/contact-us.component';
import {FaqComponent} from './components/faq/faq.component';
import {OnlineCasinoSolutionComponent} from './components/online-casino-solution/online-casino-solution.component';
import {TopGamesComponent} from './components/top-games/top-games.component';
import {IncorporationComponent} from './components/incorporation/incorporation.component';
import {PaymentIntegrationComponent} from './components/payment-integration/payment-integration.component';
import {HostingComponent} from './components/hosting/hosting.component';
import {CasinoPromotionComponent} from './components/casino-promotion/casino-promotion.component';
import {PrivacyPolicyComponent} from './components/privacy-policy/privacy-policy.component';

export const ROUTES: Routes = [
  {
    path: '', component: HomepageComponent
  },
  {
    path: 'mobile-development', component: MobileApplicationDevComponent
  },
  {
    path: 'fintech-solutions', component: FintechSolutionsComponent
  },
  {
    path: 'gaming-platform', component: GamingPlatformComponent
  },
  {
    path: 'contact-us', component: ContactUsComponent
  },
  {
    path: 'faq', component: FaqComponent
  },
  {
    path: 'online-casino-solution', component: OnlineCasinoSolutionComponent
  },
  {
    path: 'top-games', component: TopGamesComponent
  },
  {
    path: 'incorporation', component: IncorporationComponent
  },
  {
    path: 'payment-integration', component: PaymentIntegrationComponent
  },
  {
    path: 'hosting', component: HostingComponent
  },
  {
    path: 'casino-promotion', component: CasinoPromotionComponent
  },
  {
    path: 'privacy-policy', component: PrivacyPolicyComponent
  },
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts